import { ChevronDown } from "lucide-react";
import { NavLink } from "react-router-dom";
import { IToggleMobMenu } from "../../interfaces/ToggleMobMenuInterface";
import { AdditionalTitlesI } from "../../interfaces/HeaderInterface";
import {
  CollapsibleContainer,
  ToggleExpandButton,
  TogglePersonalContainer,
} from "./ToggleMobMenuStyles";
import { generateLink } from "../../functions/routingFuntion";
import { useAppSelector } from "../../store/hooks";

export const ToggleMobMenu = ({
  index,
  openIndex,
  toggleMenu,
  title,
  closeNav,
}: IToggleMobMenu) => {
  const language = useAppSelector((state) => state.locale.localStorageValue);
  const isOpen = index === openIndex;

  const setCloseZeroIndex = () => {
    toggleMenu(null);
    closeNav();
  };

  return (
    <TogglePersonalContainer>
      {title.additionalTitles.length ? (
        <div className="block__with__subtitles">
          <NavLink
            to={generateLink(title.route, language)}
            className="link__styles"
            onClick={closeNav}
          >
            {title.title}
          </NavLink>
          <ToggleExpandButton
            expanded={isOpen}
            onClick={() => toggleMenu(index)}
          >
            <ChevronDown size={25} color="white" />
          </ToggleExpandButton>
        </div>
      ) : (
        <div className="block__title">
          {title.route === "/" ? (
            <NavLink
              className="link__styles"
              to={generateLink(title.route, language)}
              onClick={setCloseZeroIndex}
            >
              {title.title}
            </NavLink>
          ) : (
            <NavLink
              to={generateLink(title.route, language)}
              className="link__styles"
              onClick={closeNav}
            >
              {title.title}
            </NavLink>
          )}
        </div>
      )}
      {title.additionalTitles.length ? (
        <CollapsibleContainer isOpen={isOpen}>
          {title.additionalTitles.map((item: AdditionalTitlesI) => {
            return (
              <li key={item.additionalTitle}>
                <NavLink
                  to={generateLink(item.route, language)}
                  onClick={setCloseZeroIndex}
                >
                  {item.additionalTitle}
                </NavLink>
              </li>
            );
          })}
        </CollapsibleContainer>
      ) : null}
    </TogglePersonalContainer>
  );
};
